import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="center">
      <div>
        <h1 style={{ fontSize: 50, marginTop: '10rem', textAlign: 'center' }}>happify privacy policy.</h1>
      </div>
      <div>
        <h2 style={{ fontSize: 18, marginTop: '3rem', textAlign: 'center' }}>happify does not collect or store any data that is used in generation of a user report, or shared to third parties.</h2>
      </div>
    </div>
  );
}

export default Privacy;